import { selectHasReadCasesPermissions } from 'app/modules/session/selectors';
import { useSelector } from 'react-redux';

import { U21Chip, U21ChipProps } from 'app/shared/u21-ui/components';
import { useToggleCaseSidebar } from 'app/modules/sidebar/hooks';
import { IconBriefcase } from '@u21/tabler-icons';

export interface U21CaseChipProps extends Omit<
  U21ChipProps,
  'id' | 'children'
> {
  id: string | number;
  label: string;
}

export const U21CaseChip = (props: U21CaseChipProps) => {
  const { id, label, ...rest } = props;
  const hasReadCasesPermission = useSelector(selectHasReadCasesPermissions);
  const toggleCaseSidebar = useToggleCaseSidebar();
  return (
    <U21Chip
      onClick={
        hasReadCasesPermission
          ? (e) => {
              e.stopPropagation();
              toggleCaseSidebar(
                typeof id === 'number' ? id : parseInt(id, 10),
                e,
              );
            }
          : undefined
      }
      icon={<IconBriefcase />}
      {...rest}
    >
      {label}
    </U21Chip>
  );
};
